import { Component, ElementRef, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'td-end',
    template: `
        <ng-template #template>
            <td mat-cell class="end"></td>
        </ng-template>`,
    styleUrls:['./col-end.component.scss']
})
export class TdEndComponent implements OnInit {

    @ViewChild('template', {read: TemplateRef, static: true})
    public template: TemplateRef<ElementRef>;

    constructor(
        private readonly viewContainerRef: ViewContainerRef,
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
    }
}
